import React, { Fragment, memo, useState } from 'react';
import { Tooltip } from 'antd';
import { CheckCircleOutlined, CopyOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useTranslation } from 'react-i18next';

import styles from '@/components/CopyableText/CCopyToClipboard/style.less';

type Props = {
  value: string;
  onCopy?: (b?: boolean) => void;
};

const CCopyToClipboard: React.FC<Props> = ({
  value,
  // onCopy,
}) => {
  const { t } = useTranslation();

  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (!copied) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };
  return (
    <CopyToClipboard text={value} onCopy={handleCopy}>
      <Tooltip
        title={
          <Fragment>
            {copied ? (
              <CheckCircleOutlined className={classNames(styles.icon, { success: copied })} />
            ) : (
              <CopyOutlined className={classNames(styles.icon, { success: copied })} />
            )}
            {copied ? t('copied_successfully') : t('click_to_copy')}
          </Fragment>
        }
      >
        <span className={styles.content} onClick={(e) => e.stopPropagation()}>
          {value}
        </span>
      </Tooltip>
    </CopyToClipboard>
  );
};
export default memo(CCopyToClipboard);
